"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileUploader = void 0;
var upload_job_1 = require("./upload-job");
var FileUploader = /** @class */ (function () {
    function FileUploader(configuration, browserHTTPClient) {
        this.configuration = configuration;
        this.browserHTTPClient = browserHTTPClient;
        this.uploadUrlEndpoint =
            'https://' + configuration.domain + '/_api/upload/url';
        this.uploadConfigurationEndpoint =
            'https://' + configuration.domain + '/_api/v2/upload/configuration';
        // To match the implement
        this.httpClient = browserHTTPClient;
    }
    /**
     * @deprecated
     * Retrieve a pre signed URL to which the file is uploaded
     */
    FileUploader.prototype.getUploadUrl = function (uploadUrlRequest) {
        return this.browserHTTPClient
            .get(this.uploadUrlEndpoint, uploadUrlRequest)
            .then(function (body) {
            return body.payload;
        }, function (error) {
            return Promise.reject(error);
        });
    };
    /**
     * @description get upload configuration
     * @param uploadConfigurationRequest
     * @returns Promise<UploadUrlResponse>
     */
    FileUploader.prototype.getUploadConfiguration = function (uploadConfigurationRequest) {
        return this.browserHTTPClient
            .post(this.uploadConfigurationEndpoint, uploadConfigurationRequest)
            .then(function (body) {
            return body.payload;
        }, function (error) {
            return Promise.reject(error);
        });
    };
    FileUploader.prototype.doUploadFile = function (_a) {
        var path = _a.path, file = _a.file, uploadToken = _a.uploadToken, version = _a.version, uploadFileRequest = _a.uploadFileRequest, uploadUrl = _a.uploadUrl;
        var uploadJob = new upload_job_1.UploadJob({
            file: file,
            path: path,
            uploadFileRequest: uploadFileRequest,
            uploadToken: uploadToken,
            uploadUrl: uploadUrl,
        });
        return uploadJob.run(this);
    };
    /**
     * @description upload a file
     * @param {string} path the destination to which the file will be uploaded
     * @param {File} file
     * @param {UploadFileRequest?} uploadFileRequest
     * @param {string?} uploadToken
     * @param {string?} uploadUrl
     * @param {string?} version
     * @returns {UploadJob}
     */
    FileUploader.prototype.uploadFile = function (path, file, uploadFileRequest, uploadToken, uploadUrl, version) {
        if (version === void 0) { version = 'v2'; }
        if (typeof path === 'object') {
            return this.doUploadFile(path);
        }
        return this.doUploadFile({
            path: path,
            file: file,
            uploadUrl: uploadUrl,
            uploadFileRequest: uploadFileRequest,
            uploadToken: uploadToken,
            version: version,
        });
    };
    /**
     * @description upload a file
     * @param {string} path the destination to which the file will be uploaded
     * @param {File} file
     * @param {UploadFileRequest?} uploadFileRequest
     * @param {string?} uploadToken
     * @param {string?} uploadUrl
     * @returns {UploadJob}
     */
    FileUploader.prototype.uploadFileV3 = function (path, file, uploadFileRequest, uploadToken, uploadUrl) {
        // unsupported
        return null;
    };
    return FileUploader;
}());
exports.FileUploader = FileUploader;
//# sourceMappingURL=browser-file-uploader.js.map